module.exports = __webpack_public_path__ + "static/media/icon_menu_3_active@2x.12a5fa7f.png";